/* Spejder Sport PDP — gallery, wishlist, accordion and mobile carousel behaviour. */
(function () {
  // Zoom lightbox scroll-lock (card 13W3yPvj, checklist item 2): the shared
  // .pswp element is a layout-level singleton (rendered once in
  // layout/theme.liquid, snippets/zoom-pswp.liquid) whose open/close
  // lifecycle isn't exposed to the trigger button — createZoom() constructs
  // the PhotoSwipe instance deep inside assets/zoom.js. Watching the
  // "pswp--open" class directly and mirroring the SAME theme:scroll:lock /
  // theme:scroll:unlock events every other overlay in this theme dispatches
  // (cart-drawer, popup, search-popdown, header-drawer — see
  // src/js/utils/scroll.js) reuses that existing lock, scoped to this PDP
  // file only — it does not touch the shared PhotoSwipe engine.
  var zoomScrollLockBound = false;
  function bindZoomScrollLock() {
    if (zoomScrollLockBound) return;
    var pswpEl = document.querySelector('.pswp');
    if (!pswpEl || !('MutationObserver' in window)) return;
    zoomScrollLockBound = true;
    var wasOpen = pswpEl.classList.contains('pswp--open');
    new MutationObserver(function () {
      var isOpen = pswpEl.classList.contains('pswp--open');
      if (isOpen === wasOpen) return;
      wasOpen = isOpen;
      document.dispatchEvent(new CustomEvent(isOpen ? 'theme:scroll:lock' : 'theme:scroll:unlock', { bubbles: true }));
    }).observe(pswpEl, { attributes: true, attributeFilter: ['class'] });
  }

  function initGallery(root) {
    var thumbs = root.querySelectorAll('[data-pdp-thumb]');
    var slidesWrap = root.querySelector('[data-pdp-slides]');
    var slides = root.querySelectorAll('[data-pdp-slide]');
    var dots = root.querySelectorAll('[data-pdp-progress] span');
    var prevBtn = root.querySelector('[data-pdp-prev]');
    var nextBtn = root.querySelector('[data-pdp-next]');
    var zoomBtn = root.querySelector('[data-pdp-zoom]');
    var main = root.querySelector('[data-pdp-main]');
    var gallery = root.querySelector('[data-pdp-gallery]');
    if (!slides.length) return;

    // The thumb rail (assets/spejder.css .spejder-pdp__thumbs) clips to
    // `--pdp-gallery-h` at every desktop width. The main image is a fixed
    // 690px square at >=1512px but a fluid aspect-ratio:1 square below that
    // (its height tracks its own flex-computed width, not a fixed value), so
    // keep the var synced to the main image's real rendered height rather
    // than hardcoding it — a ResizeObserver catches both viewport-width and
    // breakpoint-driven changes to that height.
    if (gallery && main && 'ResizeObserver' in window) {
      var syncGalleryHeight = function () {
        // getBoundingClientRect, NOT clientHeight: clientHeight excludes the
        // main box's 1px top/bottom borders, leaving the rail 2px shorter
        // than the box it must match — at 1420-1434px viewports that shaved
        // exactly the bottom border off the last thumb on 6+-image products.
        var h = main.getBoundingClientRect().height;
        if (!h) return;
        // A partial thumb at the clip edge is the design's "more below"
        // affordance — but only when enough of it shows. In the narrow
        // viewport bands where the rail's content barely exceeds the main
        // image height, the cap slices <16px off a thumb, which reads as a
        // broken box with its bottom border missing (client report
        // 2026-08-31), not as a peek. Snap the cap down to end cleanly
        // after the previous thumb in that case; real peeks (>=16px cut)
        // are left alone.
        var rail = gallery.querySelector('[data-pdp-thumbs]');
        var first = rail && rail.querySelector('[data-pdp-thumb]');
        if (first) {
          var gap = parseFloat(getComputedStyle(rail).rowGap) || 8;
          var row = first.offsetHeight + gap;
          var n = rail.children.length;
          for (var j = 1; j < n; j++) {
            var cut = j * row + first.offsetHeight - h;
            if (cut >= 16) break; // full rows above are clean; deeper cuts are real peeks
            if (cut > 0) {
              // +2 keeps the previous thumb's border off the scroll-clip
              // edge (matches the rail's padding-bottom in spejder.css).
              h = j * row - gap + 2;
              break;
            }
          }
        }
        gallery.style.setProperty('--pdp-gallery-h', h + 'px');
      };
      new ResizeObserver(syncGalleryHeight).observe(main);
    }

    var count = slides.length;
    var current = 0;

    // The gallery LOOPS (client card "Kan vi køre PDP billeder i loop",
    // 2026-09-07): past the last image comes the first, before the first
    // the last — arrows, swipes and the drawer's dots alike, so both arrows
    // stay visible at every position instead of hiding at the ends.
    //
    // Mobile lays the slides out as a native horizontal scroll-snap row.
    // A native row cannot wrap on its own, and worse, at either end iOS
    // hands a swipe that the row can't consume to the PAGE instead
    // (WebKit latches the gesture to the first scroller able to move in
    // that direction) — the "bugger lidt på sidste billede" vertical jump
    // in the client's recording. Classic fix: a clone of the last slide
    // ahead of the first and a clone of the first after the last, so the
    // row always has somewhere to go; once a swipe comes to rest on a
    // clone the row is re-seated on the real twin with an instant, pixel-
    // identical jump (settleLoop). Clones exist only while the track is a
    // scroller — desktop stacks the slides absolutely and just fades.
    var clones = null;
    var touching = false;
    var settleTimer = null;

    function trackScrolls() {
      return count > 1 && slides[1].offsetLeft !== slides[0].offsetLeft;
    }

    function makeClone(slide) {
      var clone = slide.cloneNode(true);
      clone.classList.remove('is-active');
      clone.removeAttribute('data-pdp-slide');
      clone.removeAttribute('data-index');
      clone.removeAttribute('data-zoom-image');
      clone.setAttribute('data-pdp-clone', '');
      clone.setAttribute('aria-hidden', 'true');
      // A video twin only ever shows the poster: its <video> never plays and
      // keeps no controls (nothing focusable in an aria-hidden clone).
      clone.removeAttribute('data-pdp-video');
      clone.querySelectorAll('.spejder-pdp__video video').forEach(function (video) {
        video.removeAttribute('controls');
        video.setAttribute('preload', 'none');
        video.setAttribute('tabindex', '-1');
      });
      return clone;
    }

    function syncClones() {
      if (!slidesWrap) return;
      var scrolls = trackScrolls();
      if (scrolls && !clones) {
        clones = { head: makeClone(slides[count - 1]), tail: makeClone(slides[0]) };
        slidesWrap.insertBefore(clones.head, slides[0]);
        slidesWrap.appendChild(clones.tail);
      } else if (!scrolls && clones) {
        clones.head.remove();
        clones.tail.remove();
        clones = null;
      }
    }

    // Track position of a slide index; with clones in place the real
    // slides sit one slot to the right, and -1 / count address the clones.
    function trackLeft(index) {
      return (clones ? index + 1 : index) * slidesWrap.clientWidth;
    }

    function wrap(index) {
      return ((index % count) + count) % count;
    }

    function armSettle() {
      clearTimeout(settleTimer);
      settleTimer = setTimeout(settleLoop, 100);
    }

    function settleLoop() {
      if (!clones || touching) return;
      var width = slidesWrap.clientWidth || 1;
      var left = slidesWrap.scrollLeft;
      var slot = Math.round(left / width);
      if (Math.abs(left - slot * width) > 1) return; // still moving
      if (slot === 0) {
        slidesWrap.scrollTo({ left: count * width, behavior: 'auto' });
      } else if (slot === count + 1) {
        slidesWrap.scrollTo({ left: width, behavior: 'auto' });
      }
    }

    // Product videos (client card "Afspilning af video i PDP-karrusel",
    // 2026-10-22; markup in sections/spejder-pdp.liquid) work like the
    // article video (Magnus 2026-10-22): muted and looping, sound via the
    // player's own controls. A video plays while its slide is the one shown
    // AND the gallery is on screen (scrolled or swiped to), and pauses
    // otherwise; desktop slides are only faded out, so it would keep playing
    // there. One the shopper paused stays paused until they press play.
    // Badges, zoom and the mobile dots step aside on a video slide
    // (is-video-slide), where they would sit on the player.
    var stateEl = gallery || main;
    var inView = true;

    function isVideo(slide) {
      return !!slide && slide.hasAttribute('data-pdp-video');
    }

    function videoShown(slide) {
      return inView && Number(slide.dataset.index) === current;
    }

    function syncVideos() {
      slides.forEach(function (s) {
        if (!isVideo(s)) return;
        var shown = videoShown(s);
        var video = s.querySelector('.spejder-pdp__video video');
        if (!video) return;
        if (shown && video.paused && !video.__spejderUserPaused) {
          var playing = video.play();
          if (playing && playing.catch) playing.catch(function () {});
        } else if (!shown && !video.paused) {
          video.pause();
        }
      });
      if (stateEl) stateEl.classList.toggle('is-video-slide', isVideo(slides[current]));
    }

    slides.forEach(function (s) {
      var video = isVideo(s) && s.querySelector('.spejder-pdp__video video');
      if (!video) return;
      video.muted = true;
      // Our own pauses happen once the slide is no longer shown, so a pause
      // while it IS shown came from the shopper.
      video.addEventListener('pause', function () {
        if (videoShown(s)) video.__spejderUserPaused = true;
      });
      video.addEventListener('play', function () {
        video.__spejderUserPaused = false;
      });
    });

    function render(index) {
      current = index;
      thumbs.forEach(function (t) {
        t.classList.toggle('is-active', Number(t.dataset.index) === index);
      });
      slides.forEach(function (s) {
        s.classList.toggle('is-active', Number(s.dataset.index) === index);
      });
      dots.forEach(function (d) {
        d.classList.toggle('is-active', Number(d.dataset.index) === index);
      });
      syncVideos();
    }

    if (main && 'IntersectionObserver' in window && root.querySelector('[data-pdp-video]')) {
      inView = false;
      new IntersectionObserver(function (entries) {
        inView = entries[entries.length - 1].intersectionRatio >= 0.5;
        syncVideos();
      }, { threshold: [0, 0.5] }).observe(main);
    }

    // `index` may be -1 or count (a wrap request from an arrow or swipe):
    // on the scrolling track that is a clone slot — scroll there and let
    // settleLoop re-seat; on the stacked track it simply wraps. Desktop
    // slides never overflow, so scrollTo is a harmless no-op there.
    function goTo(index, behavior) {
      var target = wrap(index);
      if (slidesWrap) {
        // Resting on a clone (e.g. a second arrow tap inside the settle
        // window)? Re-seat first, so the move starts from the real twin
        // instead of animating back across the whole track.
        if (clones) settleLoop();
        slidesWrap.scrollTo({ left: trackLeft(clones ? index : target), behavior: behavior || 'smooth' });
      }
      render(target);
    }

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        goTo(Number(t.dataset.index));
      });
    });

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        goTo(current - 1);
      });
    }

    // Q/A2 round-1 fix #2 (card 1NIULYM3): the bottom pill pager (the Om
    // produktet drawer's gallery has no thumbnail column, only these
    // pills) rendered the correct active/inactive state but was never
    // wired to actually change the slide — clicking a pill did nothing.
    // Shared with the main PDP gallery's own dots (same markup/behaviour,
    // one implementation).
    dots.forEach(function (d) {
      d.addEventListener('click', function () {
        goTo(Number(d.dataset.index));
      });
    });

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        goTo(current + 1);
      });
    }

    if (slidesWrap) {
      var scrollTicking = false;
      slidesWrap.addEventListener(
        'scroll',
        function () {
          armSettle();
          if (scrollTicking) return;
          scrollTicking = true;
          requestAnimationFrame(function () {
            var width = slidesWrap.clientWidth || 1;
            var slot = Math.round(slidesWrap.scrollLeft / width);
            var index = wrap(clones ? slot - 1 : slot);
            if (index !== current) render(index);
            scrollTicking = false;
          });
        },
        { passive: true }
      );
      // Keep the visible slide aligned to the scroll position after an
      // orientation change / breakpoint switch resizes the track (and add
      // or drop the loop clones when the layout flips between the two).
      window.addEventListener('resize', function () {
        syncClones();
        slidesWrap.scrollTo({ left: trackLeft(current), behavior: 'auto' });
      });
    }

    // Zoom lightbox (card 13W3yPvj): the .spejder-pdp__zoom button is the
    // sole Figma-wired trigger for the reused PhotoSwipe stack
    // (assets/zoom.js <zoom-images>) — slidesWrap IS that custom element
    // when there's real media (see sections/spejder-pdp.liquid); call its
    // createZoom() at the currently-visible slide's index directly, same
    // engine call zoom.js's own image-click listener makes internally.
    // window.a11y.lastElement mirrors zoom.js so focus returns to the
    // button (not a stale element) once the overlay closes.
    // Videos carry no data-zoom-image, so the lightbox holds the photos
    // only: open it at the active photo's place among them. The button is
    // hidden on a video slide (is-video-slide), so there always is one.
    if (zoomBtn && slidesWrap) {
      zoomBtn.addEventListener('click', function () {
        if (typeof slidesWrap.createZoom !== 'function') return;
        var zoomIndex = Array.prototype.indexOf.call(slidesWrap.querySelectorAll('[data-zoom-image]'), slides[current]);
        if (zoomIndex < 0) return;
        if (window.a11y) window.a11y.lastElement = zoomBtn;
        slidesWrap.createZoom(zoomIndex);
      });
      bindZoomScrollLock();
    }

    // Swipe support (Q/A2 round-1 fix #2, card 1NIULYM3) — a plain
    // touch-drag threshold on the slides track, driving the same goTo()
    // the dots/thumbs/prev/next buttons already use (wrapping past either
    // end, like them), no separate carousel logic. It only drives the
    // STACKED (fade) track — the Om produktet drawer; the scrolling track
    // pans and snaps natively, and a goTo() on top of that raced it: the
    // scroll handler had already advanced `current` mid-drag, so the
    // touchend goTo overshot by a slide while the native snap pulled the
    // other way. A touch in progress also holds the clone re-seat back
    // until the finger has lifted — a jump under a resting finger would
    // yank the slide.
    if (slidesWrap && slides.length > 1) {
      var touchStartX = null;
      slidesWrap.addEventListener(
        'touchstart',
        function (e) {
          touching = true;
          // A drag that starts on a video's control bar works its scrubber,
          // not the slides.
          var player = e.target && e.target.closest && e.target.closest('video');
          var onControls = !!player && e.touches[0].clientY > player.getBoundingClientRect().bottom - 56;
          touchStartX = onControls ? null : e.touches[0].clientX;
        },
        { passive: true }
      );
      var onTouchEnd = function (e) {
        touching = false;
        if (clones) {
          touchStartX = null;
          armSettle();
          return;
        }
        if (touchStartX === null) return;
        var deltaX = e.changedTouches[0].clientX - touchStartX;
        touchStartX = null;
        if (Math.abs(deltaX) < 30) return;
        var delta = deltaX < 0 ? 1 : -1;
        goTo(current + delta);
      };
      slidesWrap.addEventListener('touchend', onTouchEnd, { passive: true });
      slidesWrap.addEventListener('touchcancel', onTouchEnd, { passive: true });
    }

    syncClones();
    if (slidesWrap && clones) slidesWrap.scrollTo({ left: trackLeft(0), behavior: 'auto' });
    render(0);
  }

  /* The PDP hearts are part of the SAME wishlist as the product-card hearts —
     the delegated localStorage module in assets/spejder.js, keyed on
     [data-wishlist-toggle] + data-product-handle, which both PDP buttons now
     carry. This used to own a private click handler that flipped aria-pressed
     and .is-active and nothing else, so the PDP heart filled in but never
     reached the store and reset on the next load. All that is left to do for
     a subtree mounted after page load is re-read the store. */
  function initWishlist(root) {
    if (root && window.theme.spejderWishlistSync) window.theme.spejderWishlistSync();
  }

  function initAccordions(root) {
    var accordions = root.querySelectorAll('[data-pdp-accordion]');
    accordions.forEach(function (acc) {
      acc.addEventListener('toggle', function () {
        if (acc.open) {
          // Same jump family as the read-more collapse: opening e.g.
          // "Betaling" closes an expanded "Om produktet" ABOVE it, so keep
          // the accordion the user just clicked anchored on screen.
          holdScrollAnchor(acc, function () {
            accordions.forEach(function (other) {
              if (other !== acc) other.removeAttribute('open');
            });
          }, function () {
            // Settled once every other accordion is no taller than its
            // summary row. A short body stops shrinking at its 16px bottom
            // padding ~0.1s early, and those last px only go when
            // content-visibility flips at the end of the transition.
            return Array.prototype.every.call(accordions, function (other) {
              var summary = other.querySelector('summary');
              return other === acc || !summary ||
                other.getBoundingClientRect().height - summary.getBoundingClientRect().height < 1;
            });
          });
          // Q/A2 round-2 fix #1 (card 1NIULYM3): a closed <details> renders
          // its body at zero height, so the page-load read-more measurement
          // (measureReadMore, below) can't tell yet whether this accordion's
          // description actually overflows its 2-line clamp — re-measure
          // now that it's visible/has a real size.
          acc.querySelectorAll('[data-toggle-ellipsis-trigger]').forEach(measureReadMore);
        }
      });
    });
  }

  function initStickyBar(root) {
    var stickyBar = root.querySelector('[data-pdp-sticky-bar]');
    var stickyBtn = root.querySelector('[data-pdp-sticky-atc]');
    var atcBtn = root.querySelector('[data-add-to-cart]');
    // The whole-product sold-out "Skriv mig op" trigger (card FYGkhHbf part
    // 3) — scoped to the buybox's own notify button (.spejder-pdp__atc--notify)
    // so it can never resolve to a per-size sold-out pill, which also carries
    // [data-pdp-notify-trigger] (assets/spejder-pdp-overlays.js refreshCompactPills).
    var notifyBtn = root.querySelector('.spejder-pdp__atc--notify[data-pdp-notify-trigger]');
    // atcBtn is always in the DOM (visually-hidden + disabled when sold out,
    // see the comment at its markup) so its own hidden state is the single
    // source of truth for which CTA is actually visible — a
    // '[data-pdp-notify-trigger], [data-add-to-cart]' selector list resolves
    // by DOCUMENT order, not visibility, and atcBtn precedes notifyBtn in the
    // markup, so it always won there even when hidden.
    var realBtn = (atcBtn && !atcBtn.classList.contains('visually-hidden')) ? atcBtn : (notifyBtn || atcBtn);
    if (!stickyBtn || !realBtn) return;
    stickyBtn.addEventListener('click', function () {
      realBtn.click();
    });

    // Sticky-from-load (Trello "Mobil: Stickey 'tilføj til kurv' mangler på
    // PDP", 2026-08-25) — supersedes the reveal-once-scrolled-past pattern
    // from card s8nCFBGQ. The client wants the CTA reachable at every scroll
    // position: the bar is pinned to the viewport bottom from page load and
    // only hides while the in-page ATC/notify button (realBtn) itself is on
    // screen — so the "only ONE add-to-cart visible at a time" rule from
    // the s8nCFBGQ Q/A2 still holds; the earlier reverted attempt showed
    // both. Once the user scrolls past the in-page button the bar comes
    // back. Also hidden over the footer. Follows the ResizeObserver pattern
    // in initGallery — feature-guarded, no scroll listener, plain state flip
    // (Figma 4944:62307 has effects: [], no slide/fade).
    if (stickyBar && 'IntersectionObserver' in window) {
      // layout/theme.liquid renders the real footer as
      // <footer class="footer-sections"> (wraps 'group-footer'); the
      // .site-footer-wrapper class belongs to sections/footer.liquid's OWN
      // <footer>, which is not what's on the live page. Fall back to any
      // <footer> if the class ever changes; a missing footer just leaves
      // footerVisible permanently false below, so the ATC-on-screen state
      // alone still gates the bar (no crash, no dead reveal).
      var footer = document.querySelector('footer.footer-sections') || document.querySelector('footer');
      var atcOnScreen = false;
      var footerVisible = false;
      var sync = function () {
        stickyBar.classList.toggle('is-visible', !atcOnScreen && !footerVisible);
      };
      // The fixed bar covers the bottom of the viewport, so the in-page
      // button counts as "on screen" only once it has risen clear of the
      // bar — otherwise the bar would slide out while the real button is
      // still hidden behind where it just was, leaving a beat with no CTA.
      // The bar is always laid out (hidden via transform, spejder.css), so
      // its height is measurable up front; 0 on >=750px where it never
      // renders.
      var barHeight = stickyBar.offsetHeight;
      new IntersectionObserver(function (entries) {
        atcOnScreen = entries[entries.length - 1].isIntersecting;
        sync();
      }, { rootMargin: '0px 0px -' + barHeight + 'px 0px' }).observe(realBtn);
      if (footer) {
        new IntersectionObserver(function (entries) {
          footerVisible = entries[entries.length - 1].isIntersecting;
          sync();
        }).observe(footer);
      }
    }
  }

  function initRecentlyViewed() {
    // Broadcast's Shopify.Products.recordRecentlyViewed() (assets/theme.js) writes
    // the current product into the `shopify_recently_viewed` cookie that the
    // "Du har kigget på" section (sections/related.liquid -> recently-viewed.js)
    // reads on every page. The base Broadcast `product` section called this on
    // load; the custom spejder-pdp section never did, so the cookie was never
    // written and the section stayed empty. Record the view once per PDP load.
    if (window.Shopify && Shopify.Products && typeof Shopify.Products.recordRecentlyViewed === 'function') {
      Shopify.Products.recordRecentlyViewed();
    }
  }

  // Q/A2 round-2 fix #1 (card 1NIULYM3): only show the "Læs mere" toggle
  // when its description actually overflows the 2-line clamp — a fitting
  // description previously still got a toggle that did nothing on click.
  // Measures the CLAMPED state's scrollHeight vs clientHeight (bigger
  // scrollHeight == real content taller than the 2-line box == overflowing).
  // A collapsed `<details>` (main PDP accordion) or a not-yet-opened drawer
  // renders its body at zero height — that's "not measurable yet", not "the
  // text fits", so leave the button's current visibility alone in that case;
  // the accordion-toggle/dialog-open re-measure calls correct it once the
  // box has a real size. Module-level (not per-root) so the resize/load
  // listeners below can re-measure every trigger on the page in one pass,
  // whether it's the main PDP accordion or the Om produktet drawer's
  // currently-open bundle item.
  /* Scroll-anchor a layout change (Trello "Expand / collaps bug på PDP",
     card S59LA04y): collapsing "Vis mindre" at the bottom of a long
     description removes hundreds of px ABOVE the button, so the button and
     everything after it (and the sticky gallery that tracks the buybox)
     snap upwards while the scroll position stays put. Measure the anchor's
     viewport position around the mutation and shift the nearest scroll
     container (window, or the Om produktet drawer's scrolling body) by the
     same delta, so the element under the cursor stays under the cursor. */
  function getScrollParent(el) {
    var node = el && el.parentElement;
    while (node && node !== document.body && node !== document.documentElement) {
      var overflowY = window.getComputedStyle(node).overflowY;
      if ((overflowY === 'auto' || overflowY === 'scroll') && node.scrollHeight > node.clientHeight) return node;
      node = node.parentElement;
    }
    return null;
  }

  /* Corrections must land in the same frame. The theme sets `html {
     scroll-behavior: smooth }`, which turned each per-frame correction into
     a lagging smooth scroll: on the long "Om produktet" card the button flew
     off the top of the screen while collapsing (QA 2026-10-15). */
  function scrollByInstant(container, delta) {
    var el = container || document.documentElement;
    var prev = el.style.scrollBehavior;
    el.style.scrollBehavior = 'auto';
    if (container) container.scrollTop += delta;
    else window.scrollBy(0, delta);
    el.style.scrollBehavior = prev;
  }

  function withScrollAnchor(anchor, mutate) {
    if (!anchor || typeof anchor.getBoundingClientRect !== 'function') { mutate(); return; }
    var before = anchor.getBoundingClientRect().top;
    mutate();
    var delta = anchor.getBoundingClientRect().top - before;
    if (Math.abs(delta) < 1) return;
    scrollByInstant(getScrollParent(anchor), delta);
  }

  /* withScrollAnchor for a change that ANIMATES (client card 25l6raTy,
     2026-10-21): the accordions close over 0.3s (::details-content in
     spejder.css), so straight after the mutation nothing has moved yet and
     the single measurement saw no shift. Opening "Specifikationer" under a
     long, open "Om produktet" then left the shopper ~1,800px further down
     the page. Re-anchor every frame until settled() says the layout is
     final: the transition fires no transitionend and exposes no Animation,
     and stillness is no signal either (see initAccordions). A newer call
     takes over; native scroll anchoring is paused meanwhile, as in
     animateReadMore. */
  var holdRun = 0;
  function holdScrollAnchor(anchor, mutate, settled) {
    var run = ++holdRun;
    var before = anchor.getBoundingClientRect().top;
    var container = getScrollParent(anchor);
    var host = container || document.documentElement;
    mutate();
    host.style.overflowAnchor = 'none';
    var stop = Date.now() + 1500; // backstop
    (function follow() {
      if (run !== holdRun) return;
      var delta = anchor.getBoundingClientRect().top - before;
      if (Math.abs(delta) >= 0.5) scrollByInstant(container, delta);
      if (!settled() && Date.now() < stop) window.requestAnimationFrame(follow);
      else host.style.overflowAnchor = '';
    })();
  }

  /* Smooth read-more: animate the description's height between its clamped
     and full size (Web Animations, ~250ms) instead of snapping, and while
     collapsing re-anchor the button EVERY frame so the text folds up under
     a stationary "Læs mere" — the sticky gallery then glides instead of
     jumping. Reduced-motion users get the instant, scroll-anchored switch. */
  var READMORE_MS = 250;

  /* The height `desc` has in the other state, measured on a hidden,
     out-of-flow clone. Flipping is-expanded on the real element for one
     synchronous layout shrank the page under the scroll position: the
     browser clamped the scroll and its scroll anchoring moved it again, so
     on a long text (the tablet-width "Om produktet" card) "Vis mindre"
     threw the page ~3000px before the animation began (QA 2026-10-15). */
  function measureOtherState(desc, expanded) {
    var clone = desc.cloneNode(true);
    clone.classList.toggle('is-expanded', expanded);
    clone.removeAttribute('data-toggle-ellipsis');
    clone.setAttribute('aria-hidden', 'true');
    clone.style.position = 'absolute';
    clone.style.visibility = 'hidden';
    clone.style.pointerEvents = 'none';
    clone.style.left = '0';
    clone.style.top = '0';
    clone.style.width = desc.getBoundingClientRect().width + 'px';
    clone.style.height = '';
    clone.style.overflow = '';
    desc.parentNode.insertBefore(clone, desc.nextSibling);
    var height = clone.getBoundingClientRect().height;
    desc.parentNode.removeChild(clone);
    return height;
  }

  function animateReadMore(desc, btn, expand) {
    var setLabel = function () {
      btn.textContent = expand
        ? btn.dataset.lessLabel || 'Vis mindre'
        : btn.dataset.moreLabel || 'Læs mere';
      btn.setAttribute('aria-expanded', expand ? 'true' : 'false');
    };
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduced || typeof desc.animate !== 'function') {
      withScrollAnchor(btn, function () {
        desc.classList.toggle('is-expanded', expand);
        setLabel();
      });
      return;
    }
    // Where the button sits now, before anything changes: pinning the text
    // with overflow:hidden below stops its last paragraph's bottom margin
    // collapsing out of it, which alone lifts the button 8-16px.
    var anchorTop = btn.getBoundingClientRect().top;
    // Start from what is on screen (mid-animation on a quick second click),
    // and pin it before anything reads layout, so the page never reflows
    // under the reader.
    var from = desc.getBoundingClientRect().height;
    if (desc.__spejderAnim) desc.__spejderAnim.cancel();
    desc.style.overflow = 'hidden';
    desc.style.height = from + 'px';
    var to = measureOtherState(desc, expand);
    desc.classList.add('is-expanded');
    setLabel();

    // The hold loop below is the only thing that moves the page: Chrome's
    // native scroll anchoring would correct the same shift a second time.
    var root = document.documentElement;
    root.style.overflowAnchor = 'none';
    var container = getScrollParent(btn);
    var running = true;
    var hold = function () {
      if (!running) return;
      var delta = btn.getBoundingClientRect().top - anchorTop;
      if (Math.abs(delta) >= 0.5) scrollByInstant(container, delta);
      window.requestAnimationFrame(hold);
    };
    if (!expand) window.requestAnimationFrame(hold);

    var anim = desc.animate(
      [{ height: from + 'px' }, { height: to + 'px' }],
      { duration: READMORE_MS, easing: 'cubic-bezier(0.4, 0, 0.2, 1)' }
    );
    // The animation overrides this while it runs; once it ends the text
    // rests at its END height instead of snapping back to `from` for the
    // frame before finish() runs.
    desc.style.height = to + 'px';
    desc.__spejderAnim = anim;
    var finish = function () {
      running = false;
      desc.__spejderAnim = null;
      if (!expand) desc.classList.remove('is-expanded');
      desc.style.height = '';
      desc.style.overflow = '';
      // hold() stops with the animation, so its last frame's step was never
      // corrected: land the button exactly where it started.
      if (!expand) {
        var delta = btn.getBoundingClientRect().top - anchorTop;
        if (Math.abs(delta) >= 0.5) scrollByInstant(container, delta);
      }
      root.style.overflowAnchor = '';
    };
    anim.onfinish = finish;
    // A second click cancels this animation and has already stored its own
    // by the time this (async) event fires; only clean up if it has not.
    anim.oncancel = function () {
      running = false;
      if (desc.__spejderAnim === anim) {
        desc.__spejderAnim = null;
        root.style.overflowAnchor = '';
      }
    };
  }

  function measureReadMore(btn) {
    var wrap = btn.closest('[data-toggle-ellipsis-wrap]');
    var desc = wrap && wrap.querySelector('[data-toggle-ellipsis]');
    if (!desc) return;
    if (desc.classList.contains('is-expanded')) return;
    if (desc.clientHeight === 0 && desc.scrollHeight === 0) return;
    var overflows = desc.scrollHeight - desc.clientHeight > 1;
    btn.hidden = !overflows;
  }

  function measureAllReadMore() {
    document.querySelectorAll('[data-toggle-ellipsis-trigger]').forEach(measureReadMore);
  }

  var readMoreGlobalListenersBound = false;

  function initReadMore(root) {
    root.querySelectorAll('[data-toggle-ellipsis-trigger]').forEach(function (btn) {
      // Guard against double-binding: the Om produktet drawer (card
      // 1NIULYM3) re-invokes initReadMore() on the same cloned markup every
      // time its content is refreshed for a newly opened bundle item.
      if (btn.__spejderBound) return;
      btn.__spejderBound = true;
      btn.addEventListener('click', function () {
        // Generic wrap boundary (data attribute, not the main-PDP-specific
        // `.spejder-pdp__accordion-body` class) so this single read-more
        // implementation is reusable wherever a truncated description +
        // "Læs mere" toggle is needed — e.g. the Om produktet drawer's own
        // per-bundle-item description, which carries the same class AND
        // this attribute (see spejder-pdp-om-produktet-overlay.liquid).
        var wrap = btn.closest('[data-toggle-ellipsis-wrap]');
        var desc = wrap && wrap.querySelector('[data-toggle-ellipsis]');
        if (!desc) return;
        animateReadMore(desc, btn, !desc.classList.contains('is-expanded'));
      });
      // A link hidden under the fade can still take keyboard focus; the
      // browser then scrolls the clipped text inside its box and the reader
      // sees a jumbled slice. Unfold the text instead (QA 2026-10-15).
      var focusWrap = btn.closest('[data-toggle-ellipsis-wrap]');
      var focusDesc = focusWrap && focusWrap.querySelector('[data-toggle-ellipsis]');
      if (focusDesc) {
        focusDesc.addEventListener('focusin', function () {
          if (focusDesc.classList.contains('is-expanded') || btn.hidden) return;
          focusDesc.scrollTop = 0;
          animateReadMore(focusDesc, btn, true);
        });
      }
    });

    var triggers = root.querySelectorAll('[data-toggle-ellipsis-trigger]');
    triggers.forEach(measureReadMore);
    // Deferred re-measure: the Om produktet drawer clones its content and
    // calls initReadMore() BEFORE the dialog itself opens (see
    // openOmProduktet in assets/spejder-pdp-overlays.js), so the synchronous
    // measure above still sees a zero-height, not-yet-visible box. rAF fires
    // after that whole (synchronous) open sequence has finished, by which
    // point the dialog is actually open and the box has a real size.
    window.requestAnimationFrame(function () {
      triggers.forEach(measureReadMore);
    });
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(measureAllReadMore);
    }

    if (!readMoreGlobalListenersBound) {
      readMoreGlobalListenersBound = true;
      var reflow = window.theme && window.theme.debounce
        ? window.theme.debounce(measureAllReadMore, 150)
        : measureAllReadMore;
      window.addEventListener('resize', reflow);
      window.addEventListener('load', measureAllReadMore);
    }
  }

  // Exposed so the Om produktet drawer (card 1NIULYM3,
  // assets/spejder-pdp-overlays.js) can re-invoke the exact same
  // gallery/read-more/wishlist behaviour on its cloned per-bundle-item
  // content — no second gallery/toggle/wishlist implementation.
  window.theme = window.theme || {};
  window.theme.spejderPdp = window.theme.spejderPdp || {};
  window.theme.spejderPdp.initGallery = initGallery;
  window.theme.spejderPdp.initReadMore = initReadMore;
  window.theme.spejderPdp.initWishlist = initWishlist;

  function init() {
    document.querySelectorAll('.spejder-pdp').forEach(function (root) {
      initGallery(root);
      initWishlist(root);
      initAccordions(root);
      initStickyBar(root);
      initReadMore(root);
    });
    initRecentlyViewed();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
